export default __webpack_public_path__ + "static/media/next.1fc73b86.svg";